// extracted by mini-css-extract-plugin
module.exports = {"modal":"src-lib-app-containers-ObligationHandler-obligationHandler-module__modal--1Jbwj"};